import React, { Component } from 'react';
import PropTypes from 'prop-types';
import globals from "../globals";

class Heading extends Component {

    constructor(props) {
        super(props);

        this.setTitleRef = (props.setTitleRef ? props.setTitleRef : () => {return null;})
        this.setSubTitleRef = (props.setSubTitleRef ? props.setSubTitleRef : () => {return null;})
    }

    render() {
        return (
            <div className={`heading ${this.props.className ? this.props.className : ''}`}>
                {this.props.type && <div className="partner-logo" />}
                <h1
                    dangerouslySetInnerHTML={{__html: globals.noWidows(this.props.title)}}
                    ref={el => this.setTitleRef(el)}
                />
                { (this.props.subTitle && this.props.subTitle !== '') ? <h4 dangerouslySetInnerHTML={{__html: globals.noWidows(this.props.subTitle)}} ref={el => this.setSubTitleRef(el)} /> : '' }
				{this.props.children}
            </div>
        );
    }

}

Heading.propTypes = {
	title: PropTypes.string,
	subTitle: PropTypes.string
};

export default Heading;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/Heading.js